import { render } from "./Plane.vue?vue&type=template&id=6a8c12e8&scoped=true&ts=true"
import script from "./Plane.vue?vue&type=script&lang=ts"
export * from "./Plane.vue?vue&type=script&lang=ts"

import "./Plane.vue?vue&type=style&index=0&id=6a8c12e8&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8c12e8"]])

export default __exports__